import { render, staticRenderFns } from "./VacancyAdditionalFields.vue?vue&type=template&id=c54c99e8"
import script from "./VacancyAdditionalFields.vue?vue&type=script&lang=js"
export * from "./VacancyAdditionalFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports